export class AuthorizationData {
    Nome: string;
    Token: string;
    Email:string;
    CNPJ:string;

}